import React from 'react';
import { Section } from './ui/Section';
import { Highlight } from './ui/Highlight';
import { motion } from 'framer-motion';
const days = [{
  day: 'DÍA 1',
  title: 'Micro-nicho Comprable',
  desc: "No 'negocios', sino gente con dolor real."
}, {
  day: 'DÍA 2',
  title: 'Oferta en 1 Página',
  desc: 'Pack prueba + límites claros.'
}, {
  day: 'DÍA 3',
  title: '3 Muestras Sin Cliente',
  desc: 'Antes/después, demo, mock. Visibles.'
}, {
  day: 'DÍA 4',
  title: 'Lista de 20 Leads',
  desc: 'Sin spam. Gente calificada.'
}, {
  day: 'DÍA 5',
  title: '20 Mensajes con Guion',
  desc: 'Sin improvisar. Copy/paste estratégico.'
}, {
  day: 'DÍA 6',
  title: 'Cierre Simple',
  desc: 'Script de precio + siguiente paso.'
}, {
  day: 'DÍA 7',
  title: 'Entrega en 24h',
  desc: 'Y petición de renovación o referidos.'
}];
export function Solution() {
  return <Section className="bg-surface border-y border-white/10" data-id="element-141">
      <div className="text-center mb-16" data-id="element-142">
        <span className="text-primary font-mono text-sm tracking-widest uppercase mb-4 block" data-id="element-143">
          La Solución
        </span>
        <h2 className="text-4xl md:text-6xl font-display font-bold mb-6" data-id="element-144">
          AI CLIENTES EN 7 DÍAS
        </h2>
        <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-145">
          Esto es un sistema operativo de 7 días. Cada día tiene una salida
          concreta. <br data-id="element-146" />
          <span className="text-white font-bold" data-id="element-147">
            Si no la tienes, no pasas.
          </span>
        </p>
      </div>

      <div className="relative border-l-2 border-white/10 ml-4 md:ml-0 md:pl-0 space-y-12" data-id="element-148">
        {days.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        delay: index * 0.1
      }} className="relative pl-8 md:pl-0 md:grid md:grid-cols-[1fr_auto_1fr] md:gap-8 items-center group" data-id="element-149">
            {/* Mobile dot */}
            <div className="absolute -left-[9px] top-2 w-4 h-4 rounded-full bg-surface border-2 border-white/20 group-hover:border-primary group-hover:bg-primary transition-colors md:hidden" data-id="element-150"></div>

            {/* Left side (Day) */}
            <div className="md:text-right mb-2 md:mb-0" data-id="element-151">
              <span className="font-mono text-primary font-bold tracking-wider" data-id="element-152">
                {item.day}
              </span>
            </div>

            {/* Center dot (Desktop) */}
            <div className="hidden md:flex justify-center relative" data-id="element-153">
              <div className="w-4 h-4 rounded-full bg-surface border-2 border-white/20 group-hover:border-primary group-hover:bg-primary transition-colors z-10" data-id="element-154"></div>
              {/* Vertical line connector fix for grid */}
              <div className="absolute top-4 bottom-[-48px] w-0.5 bg-white/10 -z-0 last:hidden" data-id="element-155"></div>
            </div>

            {/* Right side (Content) */}
            <div className="bg-white/5 p-6 rounded-sm border border-white/5 hover:border-primary/30 transition-colors" data-id="element-156">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-157">
                {item.title}
              </h3>
              <p className="text-gray-400" data-id="element-158">{item.desc}</p>
            </div>
          </motion.div>)}
      </div>

      <div className="mt-16 text-center" data-id="element-159">
        <p className="text-2xl font-display font-bold" data-id="element-160">
          Este sprint no depende de "inspiración". <br data-id="element-161" />
          <Highlight data-id="element-162">Depende de volumen y claridad.</Highlight>
        </p>
      </div>
    </Section>;
}